module.exports = __webpack_public_path__ + "img/ico_instargram_new.82a49ebf.svg";